export default class LoginInfo {

    masterKey!: CryptoKey;
    authHash!: string;
    username!: string;

}
